<mat-spinner class="spinner" *ngIf="isLoading"></mat-spinner>
<frodo-page-shell>
  <p shell-header>{{ 'common.handedOff.reasonsTitle' | translate }}</p>
  <div class="handed_off_reason">
    <button
      *ngFor="let reason of reasons | keyvalue : noSort | slice : 0 : 4"
      class="handed_off_reason__button"
      (click)="onConfirm(reason.key)"
      [disabled]="isLoading"
    >
      {{ reason.value }}
    </button>
  </div>
</frodo-page-shell>
